import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import StockoutproductFilterCriteria from './StockoutproductFilterCriteria'
import StockoutproductList from './StockoutproductList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './StockoutproductAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setStockoutproductDashboardStockoutproductList } from '../../store/slice/ManufSlice';

export default function StockoutproductListView({setShowEdit,setStockoutproductId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.stockoutproductDashboard);   

    const [filteredStockoutproductList, setFilteredStockoutproductList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { stockoutproductDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (stockoutproductDashboard.stockoutproductList.length>-1){
        setFilteredStockoutproductList(stockoutproductDashboard.stockoutproductList);
        transformToCardFormat(stockoutproductDashboard.stockoutproductList, setCardList);
      }
    },[stockoutproductDashboard.stockoutproductList])

    useEffect(()=>{
          transformToCardFormat(filteredStockoutproductList, setCardList);
      },[filteredStockoutproductList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.stockoutreqid==='' && filterCriteria.productid==='' && filterCriteria.productname==='' && filterCriteria.qty==='' ){
            setFilteredStockoutproductList(stockoutproductDashboard.stockoutproductList);
            transformToCardFormat(stockoutproductDashboard.stockoutproductList, setCardList);

        } else {
            setFilteredStockoutproductList(
                stockoutproductDashboard.stockoutproductList
                    .filter(stockoutproduct=> stockoutproduct.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(stockoutproductDashboard.filteredStockoutproductList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <StockoutproductList
                    setShowEdit={setShowEdit}
                    setStockoutproductId = {setStockoutproductId}
                    tableList={filteredStockoutproductList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}